import {
  ICustomerContextOption,
  ICustomersSwitch,
} from '@components/SelectContext/selectContext.types';
import { ApplicationsProps } from '@config/useApps';
import { UserPreferencesReturn } from '@hooks/useUserPreferences';
import { IObject } from '@utils/defaultTypes';
import { RolesTypes } from '@utils/rolesConstants';
import { createContext } from 'react';
import { ApplicationsConstants } from '@utils/applicationsConstants';
import { UseCustomersReturnType } from '@hooks/useCustomers';
import type { DefaultTheme } from 'styled-components';
import { SmsAvailableOptions } from '@pages/Sms/SmsRequests';

const initialValue = {
  effectiveRoles: undefined,
  mainCustomerInContext: undefined,
  isRootContext: undefined,
  userLogged: undefined,
  customerLogged: undefined,
};

interface IContext {
  effectiveRoles?: { [key: string]: Array<RolesTypes> };
  setEffectiveRoles?: Function;
  hasPermission: (role: string, client?: string) => boolean | undefined;
  mainCustomerInContext?: ICustomerContextOption;
  setMainCustomerInContext: Function;
  isContextSwitchingEnabled: boolean;
  userLogged: any;
  hasCustomersRoles: boolean;
  customer: UseCustomersReturnType;
  customersSwitch?: ICustomersSwitch;
  setCustomersSwitch: Function;
  isContextSwitch: boolean | undefined;
  setIsContextSwitch: Function;
  userSettings: IObject | undefined;
  mutateUserSettings: Function;
  setUserSettings: React.Dispatch<React.SetStateAction<IObject>>;
  logoImgName: string | undefined;
  setLogoImgName: React.Dispatch<React.SetStateAction<string | undefined>>;
  mainColor: string | undefined;
  setMainColor: React.Dispatch<React.SetStateAction<string | undefined>>;
  whatsapp: string | undefined;
  whatsappMessage: string | undefined;
  selectedApp: ApplicationsConstants | undefined;
  setSelectedApp: React.Dispatch<
    React.SetStateAction<ApplicationsConstants | undefined>
  >;
  allowedPagesRouting: ApplicationsProps[] | undefined;
  getAppByName: (appName: string | undefined) => ApplicationsProps | undefined;
  allowedPaths: string[] | undefined;
  tourGuideRoute: string;
  changeGuideRoute: (routeName: string) => void;
  isNotChildOfRoot: boolean;
  isParentCustomer: boolean;
  isMot: boolean;
  motOperators: string[];
  userPreferences: UserPreferencesReturn;
  isAllcom: boolean;
  isMotBusiness: boolean;
  isRoot: boolean;
  hasOnlyMotBusiness: boolean;
  isMotPay: boolean;
  isAlgarDomain: boolean;
  algarDomains: string[];
  domainCustomerName: string | undefined;
  personalizationCompleted: boolean;
  isMotEnterprise: boolean;
  theme: DefaultTheme;
  setTheme: React.Dispatch<React.SetStateAction<DefaultTheme>>;
  themeWithMainColor: (theme: DefaultTheme) => DefaultTheme;
  firstMotProduct?: string;
  hasMotLorawan: boolean;
  isMotEssential: boolean;
  smsAvailableOptions: SmsAvailableOptions | undefined;
  graphThemeKey: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
  setGraphThemeKey: React.Dispatch<
    React.SetStateAction<'primary' | 'secondary' | 'tertiary' | 'quaternary'>
  >;
}

// @ts-ignore
const SessionContext = createContext<IContext>(initialValue);

export default SessionContext;
export { initialValue };
